export default __webpack_public_path__ + "static/4-f4d792a1c33d7462db0b84ee88089b0f.jpeg";